// extracted by mini-css-extract-plugin
module.exports = {"root":"bs_bx"};